"use strict";

var _classCallCheck = require("/Users/caseyflynn/caseycv/caseycv.com/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/caseyflynn/caseycv/caseycv.com/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GradientColorOpacityAnimation = exports.GradientAngleAnimation = exports.AnimatableGradientColor = exports.GradientColorOpacity = exports.GradientAngle = exports.AnimatableGradient = void 0;

var AnimatableColor_1 = require("./AnimatableColor");

var Utils_1 = require("../../Utils");

var AnimatableGradient = /*#__PURE__*/function () {
  function AnimatableGradient() {
    _classCallCheck(this, AnimatableGradient);

    this.angle = new GradientAngle();
    this.colors = [];
    this.type = "random";
  }

  _createClass(AnimatableGradient, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      this.angle.load(data.angle);

      if (data.colors !== undefined) {
        this.colors = data.colors.map(function (s) {
          var tmp = new AnimatableGradientColor();
          tmp.load(s);
          return tmp;
        });
      }

      if (data.type !== undefined) {
        this.type = data.type;
      }
    }
  }]);

  return AnimatableGradient;
}();

exports.AnimatableGradient = AnimatableGradient;

var GradientAngle = /*#__PURE__*/function () {
  function GradientAngle() {
    _classCallCheck(this, GradientAngle);

    this.value = 0;
    this.animation = new GradientAngleAnimation();
    this.direction = "clockwise";
  }

  _createClass(GradientAngle, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      this.animation.load(data.animation);

      if (data.value !== undefined) {
        this.value = data.value;
      }

      if (data.direction !== undefined) {
        this.direction = data.direction;
      }
    }
  }]);

  return GradientAngle;
}();

exports.GradientAngle = GradientAngle;

var GradientColorOpacity = /*#__PURE__*/function () {
  function GradientColorOpacity() {
    _classCallCheck(this, GradientColorOpacity);

    this.value = 0;
    this.animation = new GradientColorOpacityAnimation();
  }

  _createClass(GradientColorOpacity, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      this.animation.load(data.animation);

      if (data.value !== undefined) {
        this.value = (0, Utils_1.setRangeValue)(data.value);
      }
    }
  }]);

  return GradientColorOpacity;
}();

exports.GradientColorOpacity = GradientColorOpacity;

var AnimatableGradientColor = /*#__PURE__*/function () {
  function AnimatableGradientColor() {
    _classCallCheck(this, AnimatableGradientColor);

    this.stop = 0;
    this.value = new AnimatableColor_1.AnimatableColor();
  }

  _createClass(AnimatableGradientColor, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.stop !== undefined) {
        this.stop = data.stop;
      }

      this.value = AnimatableColor_1.AnimatableColor.create(this.value, data.value);

      if (data.opacity !== undefined) {
        this.opacity = new GradientColorOpacity();

        if (typeof data.opacity === "number") {
          this.opacity.value = data.opacity;
        } else {
          this.opacity.load(data.opacity);
        }
      }
    }
  }]);

  return AnimatableGradientColor;
}();

exports.AnimatableGradientColor = AnimatableGradientColor;

var GradientAngleAnimation = /*#__PURE__*/function () {
  function GradientAngleAnimation() {
    _classCallCheck(this, GradientAngleAnimation);

    this.count = 0;
    this.enable = false;
    this.speed = 0;
    this.sync = false;
  }

  _createClass(GradientAngleAnimation, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.count !== undefined) {
        this.count = data.count;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.speed !== undefined) {
        this.speed = data.speed;
      }

      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);

  return GradientAngleAnimation;
}();

exports.GradientAngleAnimation = GradientAngleAnimation;

var GradientColorOpacityAnimation = /*#__PURE__*/function () {
  function GradientColorOpacityAnimation() {
    _classCallCheck(this, GradientColorOpacityAnimation);

    this.count = 0;
    this.enable = false;
    this.speed = 0;
    this.sync = false;
    this.startValue = "random";
  }

  _createClass(GradientColorOpacityAnimation, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.count !== undefined) {
        this.count = data.count;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.speed !== undefined) {
        this.speed = data.speed;
      }

      if (data.sync !== undefined) {
        this.sync = data.sync;
      }

      if (data.startValue !== undefined) {
        this.startValue = data.startValue;
      }
    }
  }]);

  return GradientColorOpacityAnimation;
}();

exports.GradientColorOpacityAnimation = GradientColorOpacityAnimation;